/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-part-number-changes-detail-title',
    templateUrl: './part-number-changes-detail-title.component.html',
    styleUrls: ['./part-number-changes-detail-title.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PartNumberChangesDetailTitleComponent {
    @Input() sectionTitle: string;

    createDataCy(title: string): string {
        let dataCy = `pnc-detail-section-title`;
        if (title != null && title.length > 0) {
            dataCy = `${dataCy}-${title.replace(' ', '-')}`;
        }
        return dataCy;
    }
}
